import { useEffect } from 'react';

/**
 * A hook to prevent background scrolling when a modal is open
 * @param {boolean} isOpen - Whether the modal is currently open
 */
const useModalScrollLock = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      // Save the current scroll position
      const scrollY = window.scrollY;
      
      // Add the overflow-hidden class to the body
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.classList.add('overflow-hidden');
    } else {
      // If modal is closed, restore scrolling
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.classList.remove('overflow-hidden');
      
      // Restore scroll position
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    // Cleanup function to ensure we remove the class when component unmounts
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.classList.remove('overflow-hidden');
    };
  }, [isOpen]);
};

export default useModalScrollLock; 